import { io } from "socket.io-client";
 export const SocketIO = io(`${process.env.REACT_APP_SOCKET_URL}`);